import { camelCase, capitalize } from 'lodash-es';
import { IntlShape } from 'react-intl';
import messages from './messages.json';

interface Category {
  path: string;
}

const getCategoryPath = (
  category: Category,
  hasLocalNews: boolean,
  intl: IntlShape,
): string => {
  const path = category.path.replace(/\/.+/, '');

  return capitalize(hasLocalNews
    ? path
    : intl.formatMessage(
      messages[camelCase(path)],
    ));
};

export default getCategoryPath;
